import React from "react";
import { Link } from "react-router-dom";
import Valve from "./Valve";
import Flance from "./Flance";


const StructuralFramework = () => {

  return (
    <div className="flex flex-col md:flex-row bg-[#0c2341] text-white">
      <main className="">
        <h1 className="text-base md:text-2xl md:mb-3 py-2">
          <Link to="/">Home</Link> / AKT STEEL DIVISION /{" "}
          <span className="font-bold">AKT STEEL</span>
        </h1>

        <h1 className="text-2xl md:text-4xl font-bold">
          VALVE
        </h1>

        <div className="">
          <Valve />
        </div>
        <h1 className="text-2xl md:text-4xl font-bold">
          FITTINGS FLANGES
        </h1>
        <div className="">
          <Flance />
        </div>
      </main>
    </div>
  );
};

export default StructuralFramework;
